export const getEditWebsitePanelStyle = () => ({
  container: {
    fontSize: '14px',
    '& .copy-tag': {
      display: 'inline-block',
    },
    '& .tag-svg': {
      marginBottom: 38,
    },
  },
  instruction: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#323130',
    marginTop: 15,
    marginBottom: 12,
  },
  steps: {
    fontSize: '14px',
    marginBottom: 12,
  },
  platforms: {
    fontSize: '16px',
    marginBottom: 19,
  },
  platformOption: {
    fontSize: '14px',
  },
  email: {
    marginLeft: 12,
  },
});

export const editWebsitePanelStyles = {
  panel: {
    footerInner: { borderTop: '1px #EDEBE9 solid' },
    header: { paddingLeft: 32, paddingTop: 0, marginTop: '0 !important' },
    content: { paddingLeft: 32, paddingBottom: 80 },
    width: {
      Container: '920px',
      UET: '1350px',
    },
  },
};
